import { render, staticRenderFns } from "./base-swiper.vue?vue&type=template&id=fa735184&scoped=true"
import script from "./base-swiper.vue?vue&type=script&lang=js"
export * from "./base-swiper.vue?vue&type=script&lang=js"
import style0 from "./base-swiper.vue?vue&type=style&index=0&id=fa735184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa735184",
  null
  
)

export default component.exports